import { TECHNICAL_REVIEWER_SEARCH_START_LOADING, TECHNICAL_REVIEWER_SEARCH_END_LOADING, TECHNICAL_REVIEWER_SEARCH_LOADED, SET_TECHNICAL_REVIEWER_FILTER } from "../constants/TechnicalReviewerConstants";
import { TECHNICAL_REVIEWER_START_LOADING, TECHNICAL_REVIEWER_END_LOADING, TECHNICAL_REVIEWER_LOADED } from "../constants/TechnicalReviewerConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadTechnicalReviewerSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TECHNICAL_REVIEWER_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("TechnicalReviewer/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: TECHNICAL_REVIEWER_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TECHNICAL_REVIEWER_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TECHNICAL_REVIEWER_SEARCH_END_LOADING });
        }
    };
}

export function setTechnicalReviewerFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_TECHNICAL_REVIEWER_FILTER,
            payload: filter
        });
    };
}

export function loadTechnicalReviewer(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TECHNICAL_REVIEWER_START_LOADING });

        try {

            var data = await getApiData("TechnicalReviewer/GetTechnicalReviewerFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: TECHNICAL_REVIEWER_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TECHNICAL_REVIEWER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TECHNICAL_REVIEWER_END_LOADING });
        }
    };
}

export function saveTechnicalReviewer(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TECHNICAL_REVIEWER_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("TechnicalReviewer/SaveTechnicalReviewerFBO", null, fbo);
            
            if(data.success) {
                await dispatch({
                    type: TECHNICAL_REVIEWER_LOADED,
                    payload: data.responseEntities[0]
                });
                
                dispatch(commonActions.setSuccessMessage("Technical Reviewer Saved Successfully!"));
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TECHNICAL_REVIEWER_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TECHNICAL_REVIEWER_END_LOADING });
        }
    };
}